import React from "react";
import Table from "react-bootstrap/Table";
import business from "../assets/business.png";
import view from "../assets/view.png";
import del from "../assets/del.png";
import star from "../assets/star.png";
import edit from "../assets/edit.png";
import { Tablearay } from "../profile/Directoriesarray";
import social from "../assets/social.png";
import DataTable from "react-data-table-component";
import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

function PostTable(props) {
  console.log("prooops", props);
  const [allData, setAllData] = useState([]);
  const columns = [
    {
      name: "Business id/Website",
      selector: (row) => (
        <div className="d-flex">
          <input
            type="radio"
            name="fav_language"
            value={row.id}
            className="business_radio4"
            onClick={() => props.selectBusinessId(row.id)}
          />
          <div className="left-content">
            {row.id}
            <br></br>
            <span>{row.website}</span>
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Logo",
      selector: (row) => (
        <div>
          <figure className="image mr-3 item-rtl">
            <img
              src={row.logo[0].cdn_link}
              className="mt-3 mr-2"
              width="55"
              height="52"
              alt="image Preview rounded"
            />
          </figure>
        </div>
      ),
      sortable: true,
    },
    // {
    //     name: 'Date Added',
    //     selector: row => row.created_at,
    //     sortable: true,
    // },
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
    },
    {
      name: "Starting/Expire",
      selector: (row) => (
        <div>
          <p className="table_text2">
            {row.schedule_time_start != null ? row.schedule_time_start : "-"}
          </p>
          <p className="table_text2">
            {row.schedule_time_end != null ? row.schedule_time_end : "-"}
          </p>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Address",
      selector: (row) => row.address,
      sortable: true,
    },
    {
      name: "email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Price",
      selector: (row) => (row.price != "" ? row.price : "-"),
      sortable: true,
    },

    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex gap-2 align-items-center">
          <Link to={`/view/posting/${row.id}`}>
            <img src={view} className="icon" />
          </Link>
          <Link to={`/posting/update/${row.id}`}>
            <img src={edit} className="icon" />
          </Link>
          <img
            src={del}
            className="icon"
            onClick={() => props.delete(row.id)}
          />
        </div>
      ),
      sortable: true,
    },
  ];

  useEffect(() => {
    if (props.data != null) {
      if (props.dataType == "posting") {
        const data = props.data.filter((val) => {
          if (val.is_sell == false) return val;
        });
        console.log("data1", data);
        setAllData(data);
      } else {
        const data = props.data.filter((val) => {
          if (val.is_sell == true) return val;
        });
        console.log("data2", data);
        setAllData(data);
      }
    }
  }, [props]);

  return (
    <>
      <DataTable
        columns={columns}
        data={allData}
        pagination
        fixedHeader
        fixedHeaderScrollHeight="500px"
        defaultSortFieldId={1}
      />
    </>
  );
}

export default PostTable;
